import { makeRequest } from '@humanspace/infrastructure';

// Spaces
export const getSpaces = async projectId =>
  makeRequest({ path: `/projects/${projectId}/spaces` });

export const createSpace = async (projectId, spaceData) =>
  makeRequest({
    path: `/projects/${projectId}/spaces`,
    method: 'POST',
    body: spaceData,
    json: true,
  });

export const updateSpace = async (spaceId, spaceData) =>
  makeRequest({
    path: `/spaces/${spaceId}`,
    method: 'PATCH',
    body: spaceData,
    json: true,
  });

export const deleteSpace = async spaceId =>
  makeRequest({
    path: `/spaces/${spaceId}`,
    method: 'DELETE',
  });

// Brain Health Assessments
export const saveAssessment = async (projectId, assessmentData) =>
  makeRequest({
    path: `/projects/${projectId}/brainhealth/assess`,
    method: 'POST',
    body: assessmentData,
  });

export const getAssessments = async projectId =>
  makeRequest({
    path: `/projects/${projectId}/brainhealth/assessments`,
  });

// BHPS Features
export const getBhpsFeatures = async spaceId =>
  makeRequest({
    path: `/spaces/${spaceId}/bhpsfeatures`,
  });

export const updateBhpsFeatures = async (spaceId, features) =>
  makeRequest({
    path: `/spaces/${spaceId}/bhpsfeatures`,
    method: 'PUT',
    body: { features },
  });

// Population
export const getPopulation = async projectId =>
  makeRequest({
    path: `/projects/${projectId}/populations`,
  });

export const savePopulation = async (projectId, populationData) =>
  makeRequest({
    path: `/projects/${projectId}/populations`,
    method: 'POST',
    body: populationData,
  });

export const deletePopulation = async id =>
  makeRequest({
    path: `/populations/${id}`,
    method: 'DELETE',
  });
